import "./SingleProductTemplate.module.css"
import Header from "@/reusable_sections/Header"
import ProductDetail from "./sections/ProductDetail"
import Footer from "@/reusable_sections/Footer"

export default function SingleProductTemplatePage() {

  return (
    <div>
      <Header />
      <ProductDetail />
      <Footer />
    </div>
  )
}
